import payload_plugin_qLmFnukI99 from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import switch_locale_path_ssr_5csfIgkrBP from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_VrpP1JaYg8 from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_sq1MuCrqbC from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import components_plugin_KR1HBZs4kY from "/builds/shop22/kik-storefront-monorepo/storefront/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_Ug908EZNww from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt-site-config/dist/runtime/app/plugins/i18n.js";
import plugin_ghbUAjaD3n from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import _01_domain_Nr0nuy5rrj from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/01.domain.ts";
import _02_http_api_integration_TZggF0JrA8 from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/02.http.api.integration.ts";
import cookieConsent_client_EFtlI6c9bx from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/cookieConsent.client.ts";
import cookieInterceptor_client_neGnLik1z8 from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/cookieInterceptor.client.ts";
import cux_client_5cZbqe3YHN from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/cux.client.ts";
import deliveryTimes_8U5MgQKLeo from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/deliveryTimes.ts";
import eTracker_client_TXszpaKHVV from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/eTracker.client.ts";
import ehi_client_VrMConaXcx from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/ehi.client.ts";
import errorHandling_bcEBJAW9fi from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/errorHandling.ts";
import externalParties_client_EuoQWiyq5C from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/externalParties.client.ts";
import featureFlags_TJtXOhMfom from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/featureFlags.ts";
import form_validation_aBYcpGkLpn from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/form-validation.ts";
import gtm_client_OzmBuHLRIb from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/gtm.client.ts";
import luigisbox_client_nDdi0s4HXs from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/luigisbox.client.ts";
import publitas_client_Kafg93EOq0 from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/publitas.client.ts";
import trustedShops_client_6KDwhSgREz from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/trustedShops.client.ts";
import usercentrics_client_ndXLAupYuy from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/usercentrics.client.ts";
import vue_date_picker_client_AqYBdg7uuf from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/vue-date-picker.client.ts";
import vwo_client_iSRfeVlfgm from "/builds/shop22/kik-storefront-monorepo/storefront/plugins/vwo.client.ts";
import ssg_detect_3fHkBxLtv0 from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  switch_locale_path_ssr_5csfIgkrBP,
  route_locale_detect_VrpP1JaYg8,
  i18n_sq1MuCrqbC,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_Ug908EZNww,
  plugin_ghbUAjaD3n,
  _01_domain_Nr0nuy5rrj,
  _02_http_api_integration_TZggF0JrA8,
  cookieConsent_client_EFtlI6c9bx,
  cookieInterceptor_client_neGnLik1z8,
  cux_client_5cZbqe3YHN,
  deliveryTimes_8U5MgQKLeo,
  eTracker_client_TXszpaKHVV,
  ehi_client_VrMConaXcx,
  errorHandling_bcEBJAW9fi,
  externalParties_client_EuoQWiyq5C,
  featureFlags_TJtXOhMfom,
  form_validation_aBYcpGkLpn,
  gtm_client_OzmBuHLRIb,
  luigisbox_client_nDdi0s4HXs,
  publitas_client_Kafg93EOq0,
  trustedShops_client_6KDwhSgREz,
  usercentrics_client_ndXLAupYuy,
  vue_date_picker_client_AqYBdg7uuf,
  vwo_client_iSRfeVlfgm,
  ssg_detect_3fHkBxLtv0
]